var map = {
	"./logo/favicon.ico": "91a0",
	"./logo/logo.png": "a4ef",
	"./logo/logo.svg": "ed29",
	"./logo/logo1.png": "3ef9",
	"./logo/logo1.svg": "84e0",
	"./logo/logo2.png": "5ffc",
	"./logo/logo3.png": "0ba6",
	"./logo/vuexy-logo.png": "d120"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7b3d";